import React from 'react'
import {friendElement,Breadcrumb,getMandOOffice} from './myFunctions.js';
import FriendView from './FriendView.js'
import { v4 as uuidv4 } from 'uuid'; 
import { screenType } from './myFunctions.js';
/*
size HP full screen 1440
three character button 1315 
two character button 1151
one character button 978
one character 965 wrap table button (Suzanne Krekler-McClelland,Barbiel Matthews-Saunders)
one character wrap table 
one character no meeting 611
*/
export default function FriendListEntry({oym,friend,dropBreadcrumb}) {
    var friendObject= oym.objectRef(friend);
    // console.log(friend);
    // console.log(friendObject);
    // console.log(friendObject.name);
    // console.log("FIE dropBreadcrumb function:",dropBreadcrumb);
    // console.log(oym.objectRef(friend).monthlyMeeting);
    // console.log(oym.objectRef(oym.objectRef(friend).monthlyMeeting));
    var meetingObject=oym.objectRef(friendObject.monthlyMeeting);
    let meetingName=  (meetingObject!=null) ? oym.objectRef(meetingObject).name :"No Monthly Meeting";
    let friendStatus = (friendObject.status==="COOPTED_COMMUNITY_MEMBER") ? "COOPTED" : friendObject.status;
    let friendMandOOffice = getMandOOffice(oym,friend);
    let friendCell =(screenType()!=="Small") ? (<><td>{friendStatus}</td><td>{meetingName}</td><td>{friendMandOOffice}</td></>) : (<></>);
    function dropFriendBreadcrumb(e){
        console.log("Dropping friend view  breadcrumb",e);
        dropBreadcrumb(new Breadcrumb(friendObject.lastName,friendElement(oym,friendObject,dropBreadcrumb)));
    }
    return (
        <>
            <tr>
            <td><button onClick={dropFriendBreadcrumb}>{friendObject.sortKey }</button></td><td>{friendObject.name}</td>{friendCell}
            </tr>
        </>
    )
}
